import React, { FunctionComponent, JSX } from "react";
import Icon from "@ant-design/icons";
import { IIcon } from "./icons-interfaces";

const DeactivateSvg = () => (
  <svg fill="currentColor" width="1em" height="1em" viewBox="0 0 48 48">
    <path d="M16.63,5.69h-3.22c-3.23,0-5.86,2.63-5.86,5.86v25.9c0,3.23,2.63,5.86,5.86,5.86h3.22c3.23,0,5.86-2.63,5.86-5.86V11.55c0-3.23-2.63-5.86-5.86-5.86ZM18.49,37.45c0,1.03-.83,1.86-1.86,1.86h-3.22c-1.03,0-1.86-.83-1.86-1.86V11.55c0-1.03.83-1.86,1.86-1.86h3.22c1.03,0,1.86.83,1.86,1.86v25.9Z" />
    <path d="M35.59,5.69h-3.22c-3.23,0-5.86,2.63-5.86,5.86v25.9c0,3.23,2.63,5.86,5.86,5.86h3.22c3.23,0,5.86-2.63,5.86-5.86V11.55c0-3.23-2.63-5.86-5.86-5.86ZM37.45,37.45c0,1.03-.83,1.86-1.86,1.86h-3.22c-1.03,0-1.86-.83-1.86-1.86V11.55c0-1.03.83-1.86,1.86-1.86h3.22c1.03,0,1.86.83,1.86,1.86v25.9Z" />
  </svg>
);

const DeactivateIcon: FunctionComponent<IIcon> = (props): JSX.Element => (
  <Icon className={props.className} component={DeactivateSvg} />
);

export default DeactivateIcon;
